<template>
  <DashboardTemplate :navMenu="true" class="custom-certificate">
    <div class="text-left pd-b-3 disabled-on-print">
      <h2 class="mg-less">ประกาศนียบัตรรับรองการจบหลักสูตร</h2>
    </div>
    <div v-if="completes.length > 0">
      <div
        class="text-left pd-b-3 flex-display ai-center disabled-on-print custom-display"
      >
        <p class="mg-less">เลือกหลักสูตร</p>

        <el-dropdown class="mg-l-4" trigger="click">
          <span class="el-dropdown-link course-box" >
            <span class="message-over clamp1">{{
              getCourseLabel(courseProvisional)
            }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="course-box-menu">
            <el-dropdown-item v-for="item in courseList" :key="item._id">
              <div
                @click="courseProvisional = item._id"
                :title="item.name"
                class="dropdown-text-over"
              >
                {{ item.name }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          @click="selectCourse"
          type="primary"
          class="light mg-l-4"
          round
          >แสดงผล</el-button
        >
      </div>
      <div
        class="flex-display ai-center js-center pd-b-3 pd-t-3 set-certificate disabled-on-print"
      >
        <div v-loading="loading">
          <CertificateCard
              :name="user.nameTH"
              :lastName="user.surnameTH"
              :courseName="getCourseLabel(course)"
              :endDate="successDate"
            />
        </div>

        <div class="pd-l-2 ">
          <div class="pd-b-5">
            <el-button
              @click="print()"
              icon="el-icon-printer"
              circle
              size="small"
              type="warning"
            ></el-button>
          </div>
          <SocialShare
            styleIcon="warning"
            :courseName="getCourseLabel(course)"
            :message="`ประกาศนียบัตรรับรองการจบหลักสูตร ${getCourseLabel(
              course
            )}`"
            :urlCopy="`certificate/share?userId=${user.userId}&courseId=${course}&endDate=${successDate}`"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <p class="color-gray pd-t-1">*** ยังไม่มีหลักสูตรที่จบการศึกษา ***</p>
    </div>
    <div class="show-only">
      <div class="certificate-print-box">
        <CertificateCard
          :name="user.nameTH"
          :lastName="user.surnameTH"
          :courseName="getCourseLabel(course)"
          :endDate="successDate"
        />
      </div>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import SocialShare from "@/components/social/SocialShare";
import CertificateCard from "@/components/certificate/CertificateCard";
import { HTTP } from "@/service/axios.js";
import {CancelToken } from "axios";

export default {
  components: {
    DashboardTemplate,
    SocialShare,
    CertificateCard,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    courseList() {
      let courses = [];
      this.$store.state.courseList.map((item) => {
        let filter = this.completes.filter((filter) => filter._id == item._id && filter.subject.length == filter.subjectNumber);
        if (filter.length > 0) {
          courses.push(item);
        }
      });

      return courses;
    },
    token() {
      return this.$store.state.token;
    },
    successDate() {
      let filter = this.completes.filter((filter) => this.course == filter._id);
      if (filter.length > 0) {
        return filter[0].successDate;
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      courseProvisional: "",
      course: "",
      completes: [],
      loading: true,
      source:''
    };
  },
  mounted() {
    this.fetchCourseList();
    this.fetchMyCourse();
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
    },
    fetchMyCourse() {
      if (this.source) {
          this.source.cancel()
      }

      this.source = CancelToken.source()
      const cancelToken = this.source.token

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`my/course`,{cancelToken})
        .then((res) => {
          if (res.data.success) {
            this.completes = res.data.obj.complete;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          console.log("fetchCourse error", e);
        })
        .finally(() => {
          setTimeout(() => {
            let course =
              this.courseList.length > 0 ? this.courseList[0]._id : "";
            this.course = course;
            this.courseProvisional = course;

            this.loading = false;
          }, 500);
        });
    },

    getCourseLabel(course) {
      let filter = this.courseList.filter((filter) => filter._id == course);
      return filter.length > 0 ? filter[0].name : "";
    },
    selectCourse() {
      this.loading = true;
      this.course = this.courseProvisional;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    print() {
      window.print();
    },
  },
};
</script>


